/**
 * Indaleti API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateAssessmentDto { 
    subjectId: number;
    classId: number;
    termId: number;
    /**
     * Ignored: the creator is always the authenticated user. Only a platform admin may set it.
     * @deprecated
     */
    createdBy?: number;
    /**
     * Assessment name
     */
    name: string;
    /**
     * Maximum score for this assessment
     */
    maxScore: number;
    /**
     * Weighting of this assessment (0 to 1)
     */
    weight: number;
    /**
     * Type of assessment
     */
    type: CreateAssessmentDto.TypeEnum;
    /**
     * Whether this is a formal assessment
     */
    isFormal: boolean;
}
export namespace CreateAssessmentDto {
    export const TypeEnum = {
        Exam: 'EXAM',
        Test: 'TEST',
        Practical: 'PRACTICAL',
        Coursework: 'COURSEWORK'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


